module.exports = __webpack_public_path__ + "img/lunar-epic-3.d9dac1ef.jpg";